<template>
  <div>
    <liquor-tree :key="componentKey" ref="tree" class="card mb-g" :data="tree" :options="options">
      <span slot-scope="{ node }" style="width:100%" class="tree-text tree-item">
        <span class="tree-item__first-element">{{ node.text }}</span>

        <span>
          <check-permission permissions="ROLE.ADD">
            <button
              aria-label="Dodaj rolę"
              class="btn btn-light btn-icon rounded-circle hover-effect-dot waves-effect waves-themed mr-2 mb-2 btn-add"
              @click.stop="addRole(node.id)"
            >
              <i :style="{ color: ADD_ACTION.color }" :class="ADD_ACTION.icon" />
            </button>
          </check-permission>

          <check-permission entity-type="role" permissions="ROLE.UPDATE" :entity-id="node.id">
            <button
              aria-label="Edytuj rolę"
              class="btn btn-light btn-icon rounded-circle hover-effect-dot waves-effect waves-themed mr-2 mb-2 btn-edit"
              @click.stop="showEditModal(node.id)"
            >
              <i :style="{ color: EDIT_ACTION.color }" :class="EDIT_ACTION.icon" />
            </button>
          </check-permission>

          <check-permission permissions="PERMISSION_RELEATION.LIST">
            <router-link :to="{ name: 'permissions', params: { roleId: node.id } }">
              <button
                class="btn btn-light btn-icon rounded-circle hover-effect-dot waves-effect waves-themed mr-2 mb-2 btn-key"
              >
                <i class="fal fa-key" />
              </button>
            </router-link>
          </check-permission>

          <check-permission entity-type="role" permissions="ROLE.DELETE" :entity-id="node.id">
            <button
              aria-label="Usuń rolę"
              class="btn btn-light btn-icon rounded-circle hover-effect-dot waves-effect waves-themed mr-2 mb-2 btn-delete"
              @click.stop="showDeleteDialog(node.id)"
            >
              <i :style="{ color: DELETE_ACTION.color }" :class="DELETE_ACTION.icon" />
            </button>
          </check-permission>
        </span>
      </span>
    </liquor-tree>

    <role-modal
      :id="idToEdit"
      :parent-id="parentId"
      :show="showModal"
      @save="add"
      @close="hideRoleModal"
      @update="update"
    />
  </div>
</template>

<script>
import LiquorTree from 'liquor-tree';
import { mapState } from 'vuex';

import RoleModal from '@/components/modals/RoleModal';
import { Errors } from '@/enums/errors.enum';
import { Successes } from '@/enums/successes.enum';
import { modalFormMixin } from '@/mixins/modalForm';
import store from '@/store/store';
import { ADD_ACTION, DELETE_ACTION, EDIT_ACTION } from '@/utils/constants';
import { buildTree } from '@/utils/tree';

// @vuese
// Drzewo ról
// @group Role
export default {
  components: {
    LiquorTree,
    RoleModal
  },
  mixins: [
    modalFormMixin('role', {
      getError: 'Wystąpił błąd podczas pobierania danych roli.',
      added: 'Dodano rolę.',
      addError: 'Nie udało się dodać roli.',
      updated: 'Zaktualizowano dane roli.',
      updateError: 'Nie udało się zaktualizować danych roli.'
    })
  ],
  data() {
    return {
      componentKey: 0,
      options: {
        checkbox: false,
        propertyNames: {
          text: 'name'
        }
      },
      parentId: undefined,
      EDIT_ACTION,
      DELETE_ACTION,
      ADD_ACTION
    };
  },
  computed: mapState({
    tree(state) {
      const roles = state.role.list.map(role => ({ ...role, state: { expanded: true, selectable: false } }));
      return buildTree(roles);
    }
  }),

  watch: {
    '$store.state.role.list'(val) {
      this.forceUpdate();
    }
  },
  methods: {
    // @vuese
    // Odświeża drzewo
    forceUpdate() {
      this.componentKey++;
    },
    // @vuese
    // Dodaje rolę
    addRole(id) {
      this.parentId = id;
      this.showAddModal();
    },
    // @vuese
    // Chowa modal
    hideRoleModal() {
      this.parentId = undefined;
      this.hideModal();
    },
    // @vuese
    // Otwiera okienko z potwierdzeniem usunięcia
    showDeleteDialog(id) {
      this.$store.commit('showConfirm', {
        title: 'Usuwanie',
        description: 'Czy na pewno chcesz usunąć rolę?',
        onSuccess: () => this.remove(id)
      });
    },

    // @vuese
    // Usuwa encję
    remove(id) {
      this.$store
        .dispatch(`role/remove`, id)
        .then(() => this.notifySuccess(Successes.ROLE_REMOVED))
        .catch(err => this.notifyError(Errors.ROLE_CANNOT_REMOVE));
    }
  }
};
</script>

<style>
.tree-item {
  display: flex;
  align-items: center;
  justify-content: center;
}

.tree-item__first-element {
  flex: 1;
}
</style>
